import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "overlay", "count", "idsInput"]
  
  connect() {
    this.updateState()
  }
  
  toggle(event) {
    this.updateState()
  }
  
  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(cb => cb.checked = checked)
    this.updateState()
  }
  
  updateState() {
    const selected = this.selectedIds
    const hasSelection = selected.length > 0
    
    // Show/hide overlay
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.toggle('d-none', !hasSelection)
    }
    
    // Update count
    if (this.hasCountTarget) {
      this.countTarget.textContent = selected.length
    }
    
    // Update hidden inputs in all forms (for submit)
    this.idsInputTargets.forEach(input => {
      input.value = selected.join(',')
    })
    
    // Update selectAll checkbox state
    if (this.hasSelectAllTarget) {
      const totalCheckboxes = this.checkboxTargets.length
      this.selectAllTarget.checked = totalCheckboxes > 0 && selected.length === totalCheckboxes
      this.selectAllTarget.indeterminate = hasSelection && selected.length < totalCheckboxes
    }
  }
  
  get selectedIds() {
    return this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)
  }
}
